import React from 'react';

import AppCheckbox from '../../../modules/app-checkbox/app-checkbox';
import IconBtn from '../../../modules/icon-btn/icon-btn';
import currencyFormat from '../../../utils/currencyFormat';
import { getOrderDetailedStatusBadge } from '../../../utils/getStatusBadge';
import { OrderDetailedItemProps } from '../types';

import DotsIcon from './dots-icon.svg';

import './order-detailed-item.scss';

interface OrderDetailedItemMergeProps extends OrderDetailedItemProps {
  orderId: number;
  selected: boolean;
  onItemClick: (val: boolean) => void;
  goDetailedPosition: (id: number, itemId: number, attached?: boolean) => void;
  isInitiator: boolean;
}

const OrderDetailedItem: React.FC<OrderDetailedItemMergeProps> = ({
  positionStatus,
  id,
  isInitiator,
  orderId,
  goDetailedPosition,
  selected,
  onItemClick,
  number,
  positionSum,
  positionAmount,
  positionCount,
}) => {
  const isDisabledCheckbox = () =>
    (isInitiator && positionStatus !== 'UCP_ISSUING_REQUIRED') ||
    (!isInitiator && positionStatus !== 'UCP_PAYMENT_REQUIRED');

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div className="order-realization-item">
      <div className="order-realization-item__checkbox">
        <AppCheckbox
          disabled={isDisabledCheckbox()}
          checked={selected}
          onChangeValue={(val) => {
            onItemClick(val);
          }}
        />
      </div>
      <div
        className="order-realization-item__number"
        onClick={() => {
          if (
            positionStatus === 'ADJUSTMENT_REQUIRED' ||
            positionStatus === 'ADJUSTMENT_CORRECTED' ||
            positionStatus === 'ADJUSTMENT_AGREEMENT' ||
            positionStatus === 'ADJUSTMENT_REJECTED'
          ) {
            goDetailedPosition(orderId, id, true);
          } else {
            goDetailedPosition(orderId, id);
          }
        }}
      >
        {number}
      </div>
      <div className="order-realization-item__position">
        {currencyFormat(positionCount, false)}
      </div>
      <div className="order-realization-item__amount">
        {currencyFormat(positionAmount, false)}
      </div>
      <div className="order-realization-item__sum">
        {currencyFormat(positionSum)}
      </div>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div className="order-realization-item__status">
        {getOrderDetailedStatusBadge(positionStatus)}
      </div>
      <div className="order-realization-item__action">
        <IconBtn icon={DotsIcon} />
      </div>
    </div>
  );
};

export default OrderDetailedItem;
